<template>
    <div class="app">
        <div class="title">卡逸客用户版</div>   
        <div class="content">
            <img class="userIcon" src="../../assets/images/head.png" alt="">
            <input class="phone" type="tel" maxlength="11" placeholder="请输入手机号" v-model="phon">
            <div class="msg" v-if="!isShow">
                <input class="verify" type="tel" maxlength="4" placeholder="短信验证码" v-model="verifyCode">
                <input class="obtain" type="button" @click="sendOne" v-model="countOne">
            </div>
            <div class="msg" v-if="isShow">
                <input class="verify" type="text" minlength="8" maxlength="16" placeholder="请填写密码">
            </div>
            <button class="login" @click="verifyLogin">登录</button>
            <div class="footer">
                <!-- <span @click="goForgetPage">忘记密码？</span>
                <span v-if="!isShow">用密码登录</span>
                <span v-if="isShow">使用短信验证码登录</span> -->
            </div>    
        </div>
        <span class="statement">未注册的手机号验证后自动创建卡逸客账户</span>
        <mt-popup v-model="popupVisible" position="top" class="mint-popup-2" :modal="false">
            <p v-text="msg"></p>
        </mt-popup>
    </div>
</template>
<script>
import validation from "../../assets/js/validation";
import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
import axios from "axios";
import store from "@/vuex/store";
import { mapState } from "vuex"; 
import global from "../../../static/js/global";
import config from "../../../static/js/config";
export default {
    data(){
        return{
            isShow: false,
            popupVisible:false,
            active: true,
            msg:"",
            verifyCode:"5349",                // 验证码
            phon:"17719313010",                      // 手机号
            countOne:"点击获取",
            wsOne:"",
        }
    },
    methods:{
        //跳转忘记密码页面
        goForgetPage()
        {
            this.$router.push({ name:"forget" });
        },
        // 计时重发
        timer(){

            setInterval(() => {
                //const one = this.downTime;
                if (this.countOne > 1) {
                  this.countOne--;
                } else {
                  this.active = true;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.countOne = "重发";
                }
              }, 1000)
        },
        // 发送验证码
        newSend(){          
            var regu1 = /^1\d{10}$/;
            if (regu1.test(this.phon))
            {
                this.verify = false;
                // 获取验证码   
                axios.get(sendVerification+this.phon,{
                })
                .then(res => {
                    console.log(res);
                  if(res.data.s==0)
                  {
                      Indicator.close()
                      //this.active = true;
                      this.countOne = res.data.nextTime;
                      this.timer();
                  }
                  else
                  {
                      this.active=false;
                  }

                    //this.numS = res.data.s;

                    switch (res.data.s) {
                      case 0:
                         Indicator.close()
                        // this.msg = "发送成功";
                        // this.popupVisible = true;
                        Toast: Toast({
                            message: '发送成功',
                            position: 'middle',
                            duration: 1000
                        });
                        break;
                      case 1026:
                         Indicator.close()
                        // this.msg = "操作频繁,请稍后再试";
                        // this.popupVisible = true;
                        Toast: Toast({
                            message: '操作频繁,请稍后再试',
                            position: 'middle',
                            duration: 3000
                        });
                        break;
                      case 1001:
                         Indicator.close()
                        //  this.msg = "系统错误";
                        // this.popupVisible = true;
                        Toast: Toast({
                            message: '系统错误',
                            position: 'middle',
                            duration: 3000
                        });
                          break;
                      case 1022:
                         Indicator.close()
                        // this.msg = "请输入正确的验证码";
                        // this.popupVisible = true;
                        Toast: Toast({
                            message: '请输入正确的验证码',
                            position: 'middle',
                            duration: 3000
                        });
                      case 1008:
                         Indicator.close()
                        // this.msg = "账号未激活";
                        // this.popupVisible = true;
                        // this.showLoading = false;
                        Toast: Toast({
                            message: '账号未激活',
                            position: 'middle',
                            duration: 3000
                        });
                        break;
                    }
                })
                .catch(err=>{
                   Indicator.close();
                   //this.active = true;
                    Toast({
                        message: '网络不给力',
                        position: 'middle',
                        duration: 2500
                       }) 
                    });

              } 
        },
        //发送验证码按钮
        sendOne() {

            if (!this.active)
            {
                return false;
            }

            this.active = false;

            if(!(/^1[3,4,5,7,8]\d{9}$/.test(this.phon)))
            {
                this.msg = "请输入正确的手机号";
                this.popupVisible = true;
            }
            else
            {
                Indicator.open({
                      text: '发送中...',
                      spinnerType: 'fading-circle'
                });

            }
            console.log('11');
            setTimeout(this.newSend,1000)
        },
        // 检查登录返回
        checkLoginBack()
        {
            
            if(isLoginBack)
            {
              console.log('isLoginBack',isLoginBack);
              console.log('-----');
              console.log("loginData",response);
              if (response.s == 0) 
              {   
                    var newObj = 
                    {
                        newPhone: this.phon,
                        uid: response.uid,
                        sessionId: response.sessionId,
                        sign: response.sign,
                        mode:response.mode
                    };
                  
                      if(!isDev)
                      {
                  
                          NativeStorage.setItem
                          (
                            "newObj",newObj,
                            this.onGetSucc,
                            this.onGetError
                          );
                      }
                      else
                      {
                          localStorage.setItem("newObj", newObj);
                      }
                      
                      uid = response.uid;
                      sessionId = response.sessionId;
                      sign=response.sign;
                      mode=response.mode;
                      isLoginSucc = true;
                      this.$store.commit("phone", this.phon);
                      this.$router.push({ name: "cardBag" });
                } 
                else if (response.s == 1040 || response.s == 1022 || response.s == 1023) 
                {
                //   console.log('helloName');
                //   this.msg = "请输入正确的验证码";
                //   this.popupVisible = true;
                    Toast({
                        message: '验证码错误，请重新输入！',
                        position: 'middle',
                        duration: 3000
                        });
                } 
                else if (response.s == 1008)
                {
                    this.msg = "用户不存在";
                    this.popupVisible = true;
                } 
                else if (response.s == 1021) 
                {
                  this.msg = "无效的手机号";
                  this.popupVisible = true;
                }
                else if (response.s == 1021) 
                {
                  this.msg = "系统繁忙";
                  this.popupVisible = true;
                }
                 else if (response.s == 1040) 
                {
                  this.msg = "验证码不正确";
                  this.popupVisible = true;
                }
            }
            else
            {
               console.log('setTime');
               setTimeout(this.checkLoginBack, 500);
            }
        },
        //  验证码登录
        verifyLogin()
        {
            console.log(1)
            if(!this.phon)
            {
                // this.msg = "请输入正确的手机号";
                // this.popupVisible = true;
                Toast({
                    message: '请输入正确的手机号',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            if(!(/^1[3,4,5,7,8]\d{9}$/.test(this.phon)))
            {
                // this.msg = "请输入正确的手机号";
                // this.popupVisible = true;
                Toast({
                    message: '请输入正确的手机号',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            else if(!(/^\d{4}$/.test(this.verifyCode)))
            {
                // console.log('12212');
                // this.msg = "请输入正确的验证码";
                // this.popupVisible = true;
                Toast({
                    message: ' 验证码错误，请重新输入！',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            else if(this.verifyCode=="")
            {
                // this.msg = "请输入正确验证码";
                // this.popupVisible = true;
                Toast({
                    message: '验证码错误，请重新输入！',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            console.log('hahah');
            if (this.phon && this.verifyCode)
            {
                // 手机验证码登录 获取用户信息
                var phonOne='"'+'mobile'+'":'+'"'+this.phon+'"'
                var passOne='"'+'verify'+'":'+'"'+this.verifyCode+'"'
                if(ws.readyState==1)
                {   
                    console.log('1212');
                    ws.send('{"action":"LoginWithMobileVerifyCode",'+phonOne +","+passOne +"}");
                    console.log('3434');
                    ws.onmessage=function(res)
                    {
                        var loginData = JSON.parse(res.data);
                        if (loginData.action == "LoginWithMobileVerifyCode")
                        {
                            isBack = true;
                            disPatchMsg(res);
                        }
                        console.log('onmessage',res);
                    }
                }
                else
                {
                    reconnect();
                }
                console.log('0909');
                this.checkLoginBack();
                    
            }

        },

        // 存储成功
         onGetSucc(obj)
        {
          //  alert("存储数据成功onGetSucc:"+obj.uid+"sign:"+obj.sign+"mode:"+obj.mode+"sessionId:"+obj.sessionId)
        },
        // 存储失败
        onGetError(obj)
        {
          // alert("存储数据失败onGetError:"+obj)
        },
        oneSelf(pass) {
          //  console.log(pass)
          var regu2 = /^\d{4}$/;
          if (regu2.test(pass)) {
            //手机号验证通过需执行的代码
          } else {
            this.popupVisible = true;
            // this.sendTne = false;
            // this.msg="请输入正确的验证码"
          }
        }
        
    },
    watch:{
        popupVisible(val){
            if(val){
                setTimeout(() => {
                    this.popupVisible = false;
                },2000);
            }
        }
    },
}
</script>
<style scoped>
.app{
    background-color: #fff;
    width: 100%;
    height: 100%;
}
.title{
    font-size: 0.53rem;
    width: 100%;
    height: 0.76rem;
    text-align: center;
    padding-top: 0.42rem;
}
.content{
    width: 100%;
    height: 100%;
}
.userIcon{
    width: 2.89rem;
    height: 2.89rem;
    position: relative;
    top: 2.47rem;
    left: 3.5rem;
}
.phone{
    display: block;
    width: 8.02rem;
    height: 1.18rem;
    font-size: 0.42rem;
    text-align: left;
    line-height: 0.61rem;    
    border: 0.03rem solid rgba(187, 187, 187, 1);
    border-radius: 0.11rem;
    padding-left: 0.4rem;
    position: relative;
    top: 3.45rem;
    left: 0.71rem;
}
.msg{
    position: relative;
    top: 3.71rem;
}
.verify{
    width: 8.02rem;
    height: 1.18rem;
    font-size: 0.42rem;
    text-align: left;
    line-height: 0.61rem;    
    border: 0.03rem solid rgba(187, 187, 187, 1);
    border-radius: 0.11rem;
    position: absolute;
    left: 0.71rem;
    padding-left: 0.4rem;
}
.obtain{
    width: 2.11rem;
    height: 0.92rem;
    line-height: 0.61rem;
    border-radius: 0.11rem;
    font-size: 0.42rem;
    border: 0.03rem solid rgba(0, 0, 0, 1);
    background-color: #fff;
    position: absolute;
    top: 0.14rem;
    left: 6.82rem;
}
.login{
    width: 8.42rem;
    height: 1.18rem;
    line-height: 0.61rem;
    border: none;
    border-radius: 0.11rem;
    background-color: rgba(41, 158, 173, 1);
    color: rgba(255, 255, 255, 1);
    letter-spacing: 0.2rem;
    font-size: 0.42rem;
    text-align: center;
    position: relative;
    top: 5.92rem;
    left: 0.74rem;
}
.footer{
    position: relative;
    top: 6.4rem;
    font-size: 0.37rem;
    color:rgba(41, 158, 173, 1); 
}
.footer :nth-child(1){
    position: absolute;
    left: 1rem;
}
.footer :nth-child(2){
    position: absolute;
    /* left: 7.08rem; */
    right: 0.89rem;
}
.statement{
    position: absolute;
    font-size: 0.37rem;
    color: rgba(187, 187, 187, 1);
    bottom: 1.16rem;
    left: 1.42rem;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue